var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { class: _vm.componentClass, style: _vm.componentStyle },
    [
      !_vm.hasNoTitle
        ? _c(
            "h2",
            {
              class: _vm.titleClass,
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-xl)",
                "font-weight": "var(--font-weight-bold)",
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }